import { forwardRef } from 'react';
import styled from 'styled-components';
import { usePost } from '../Post';
import {
  CardActionsBlock,
  CardContainer,
  CardMediaBlock,
  CardPreviewLinkBlock,
  CardRepostPreviewBlock,
  CardTextBlock,
  CardUserBlock
} from '../parts';
import { usePostSettings } from '../utils';

interface PopupFeedProps {
  space: number;
}

export const PopupFeed = forwardRef<HTMLDivElement, PopupFeedProps>(
  ({ space, ...forwardingProps }, forwardingRef) => {
    const { showMedia, showTextLink } = usePost();
    const { backgroundColor, textColor, popupMediaBackgroundColor } =
      usePostSettings();

    return (
      <Container
        {...forwardingProps}
        ref={forwardingRef}
        _space={space}
        _backgroundColor={backgroundColor}
        _dividerColor={textColor}
        _borderRadius={0}
      >
        <CardUserBlock withSource layout="feed" />

        {showMedia && (
          <CardMediaBlock
            popupMediaBackgroundColor={popupMediaBackgroundColor}
          />
        )}

        <CardTextBlock />

        <CardRepostPreviewBlock />

        {showTextLink && <CardPreviewLinkBlock />}
        <CardActionsBlock />
      </Container>
    );
  }
);

PopupFeed.displayName = 'PopupFeedCard';

const Container = styled(CardContainer)<{
  _dividerColor: string;
}>`
  max-width: 600px;

  &:not(:last-child)::after {
    content: '';
    width: 100%;
    height: 8px;
    opacity: 0.1;
    background: ${({ _dividerColor }) => _dividerColor};
  }
`;
